<ion-content>
  <div class="kb">
    <h2>Konrád nyuszi – a beépített segéd</h2>
    <p class="halvany">
      Konrád a program használatában segít: a kézikönyvből válaszol, odanavigál, a kolléga saját adataiból lekérdez,
      és előkészít műveleteket (pl. jelenlét, helyettesítés-bejelentés), amelyeket a kolléga egy gombbal hagy jóvá.
      Mindig a kolléga saját jogával dolgozik.
    </p>

    <div class="ures" *ngIf="toltodik"><ion-spinner name="dots"></ion-spinner></div>

    <ng-container *ngIf="!toltodik">
      <label class="sor kapcsolo">
        <input type="checkbox" [(ngModel)]="b.bekapcsolva"> Bekapcsolva ennél az intézménynél
      </label>
      <label class="sor kapcsolo">
        <input type="checkbox" [(ngModel)]="b.folyamatos"> Folyamatos válasz – a szöveg szavanként jelenik meg, ahogy a modell írja
        (kikapcsolva a teljes válasz egyben, a végén)
      </label>

      <div class="sor">
        <span class="cimke">Modell</span>
        <label><input type="radio" name="szolg" value="ollama" [(ngModel)]="b.szolgaltato"> Helyi modell (Ollama) – az adat a rendszerben marad</label>
        <label><input type="radio" name="szolg" value="claude" [(ngModel)]="b.szolgaltato"> Claude (Anthropic API) – ha nincs megfelelő gép</label>
      </div>

      <ng-container *ngIf="b.szolgaltato === 'ollama'">
        <div class="sor">
          <span class="cimke">Ollama címe</span>
          <input type="text" [(ngModel)]="b.ollama_url" placeholder="http://192.168.1.50:11434">
          <small>A gép, amelyen az Ollama fut; a SULINFORM szerverének el kell érnie.</small>
        </div>
        <div class="sor">
          <span class="cimke">Modell neve</span>
          <input type="text" [(ngModel)]="b.ollama_modell" [placeholder]="alap.ollama_modell || 'qwen2.5:14b'">
          <small>Eszközhívásra képes modell kell (pl. qwen2.5:14b, qwen2.5:32b). Üresen: {{ alap.ollama_modell }}.</small>
        </div>
      </ng-container>

      <ng-container *ngIf="b.szolgaltato === 'claude'">
        <div class="sor">
          <span class="cimke">API-kulcs</span>
          <input type="password" [(ngModel)]="kulcs" [placeholder]="vanKulcs ? 'Be van állítva – csak cseréhez írd be' : 'sk-ant-…'" autocomplete="new-password">
          <label *ngIf="vanKulcs" class="kicsi"><input type="checkbox" [(ngModel)]="torolKulcs"> A tárolt kulcs törlése</label>
        </div>
        <div class="sor">
          <span class="cimke">Modell</span>
          <input type="text" [(ngModel)]="b.claude_modell" [placeholder]="alap.claude_modell">
          <small>Üresen: {{ alap.claude_modell }}. Olcsóbb, gyorsabb változat: claude-haiku-4-5.</small>
        </div>
        <p class="figyelem">
          Claude-üzemmódban a kérdés és a hozzá lekért saját adat (pl. a kolléga órarendje) az Anthropic szerverére megy.
          Ehhez az iskola adatkezelési tájékoztatójában ki kell térni rá.
        </p>
      </ng-container>

      <div class="gombok">
        <ion-button (click)="mentes()" [disabled]="ment">Mentés</ion-button>
        <ion-button fill="outline" (click)="probal()" [disabled]="proba || ment">{{ proba ? 'Próba…' : 'Próba' }}</ion-button>
      </div>
      <p class="uzenet" *ngIf="uzenet" [class.rossz]="!uzenet.ok">{{ uzenet.szoveg }}</p>
    </ng-container>
  </div>
</ion-content>
